import { pbjExportActions } from './constant';
import { IPbjExportRequest } from 'src/services/pbjService/types';

const { GET_PBJ_EXPORT_REQUEST, GET_PBJ_EXPORT_RESET } = pbjExportActions;

export const getPbjExportRequest = (payload: IPbjExportRequest) => {
  return {
    type: GET_PBJ_EXPORT_REQUEST,
    payload,
  };
};

/**
 * Clears the last result. The card dispatches this the moment the file has been handed to the
 * browser, and whenever the selected quarter changes, so neither the bytes nor a stale message
 * outlives the request they belong to.
 */
export const resetPbjExport = () => {
  return {
    type: GET_PBJ_EXPORT_RESET,
  };
};
